/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/3/2022
 */

import ReminderTriggerItem from "@shared/scheduler/reminders/ReminderTriggerItem";

export default class ReminderTriggerItemNow extends ReminderTriggerItem {


	constructor() {
		super(0);
	}
}
